import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const SvgAuthGradientBackground = (props: SvgProps) => (
  <Svg
    viewBox="0 0 732 576"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    {...props}
  >
    <g opacity="0.8" filter="url(#filter0_fn_4982_54911)">
      <ellipse
        opacity="0.3"
        cx="499"
        cy="383.394"
        rx="217"
        ry="94.5"
        fill="#FFEB80"
      />
      <ellipse
        cx="81.8977"
        cy="438.344"
        rx="223.132"
        ry="97.9002"
        fill="#A661FF"
      />
      <ellipse
        cx="63.1521"
        cy="496.017"
        rx="219.366"
        ry="152.703"
        fill="#788FF5"
      />
      <ellipse
        cx="-71.1657"
        cy="312.72"
        rx="152.834"
        ry="100.827"
        fill="black"
      />
      <ellipse
        cx="323.062"
        cy="515.057"
        rx="248.897"
        ry="181.206"
        fill="#DA6AF3"
      />
      <ellipse
        cx="99.5209"
        cy="709.295"
        rx="226.753"
        ry="165.021"
        fill="#FFD580"
      />
      <ellipse
        cx="249.079"
        cy="578.83"
        rx="226.753"
        ry="165.021"
        fill="#FFD873"
      />
      <ellipse
        cx="727.839"
        cy="714.165"
        rx="233.174"
        ry="169.729"
        fill="#FFD580"
      />
      <ellipse
        cx="523.499"
        cy="515.109"
        rx="183.041"
        ry="151.181"
        fill="#F4408E"
        fillOpacity="0.94"
      />
      <ellipse cx="702" cy="596.394" rx="183" ry="126.5" fill="#EF196E" />
      <ellipse cx="613.5" cy="426.894" rx="102.5" ry="51" fill="#FFB3C3" />
      <ellipse
        cx="3.86235"
        cy="555.381"
        rx="82.375"
        ry="40.3033"
        fill="#0029FF"
      />
      <ellipse
        cx="22.1824"
        cy="536.194"
        rx="100.397"
        ry="59.6002"
        fill="#1AFFD9"
      />
    </g>
    <defs>
      <filter
        id="filter0_fn_4982_54911"
        x="-435.893"
        y="0.000106812"
        width="1608.8"
        height="1095.79"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="105.947"
          result="effect1_foregroundBlur_4982_54911"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="1.236913800239563 1.236913800239563"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3693"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect1_foregroundBlur_4982_54911"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(0, 0, 0, 0.2)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect2_noise_4982_54911">
          <feMergeNode in="effect1_foregroundBlur_4982_54911" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
    </defs>
  </Svg>
);

export default SvgAuthGradientBackground;
